import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import catalogList from './catalogList/reducer';
import activeIngredient from './activeIngredient/reducer';
import unit from './unit/reducer';
import dosageForm from './dosageForm/reducer';
import dosageFormGroup from './dosageFormGroup/reducer';
import salt from './salt/reducer';
import dispensingUnit from './dispensingUnit/reducer';
import routeAdministration from './routeAdministration/reducer';
import routeAdministrationGroup from './routeAdministrationGroup/reducer';
import dataMedication from './dataMedication/reducer';
import atc from './atc/reducer';
import unspscFamily from './unspscFamily/reducer';
import unspscClass from './unspscClass/reducer';
import unspsc from './unspsc/reducer';
import news from './news/reducer';
import article from './article/reducer';
import search from './search/reducer';
import user from './user/reducer';
import demand from './demand/reducer';
import acquisition from './acquisition/reducer';
import supplier from './supplier/reducer';
import acquisitionDetail from './acquisitionDetail/reducer';
import code22 from './code22/reducer';
import code22Review from './code22Review/reducer';
import dashboard from './dashboard/reducer';
import kpiMatrix from './kpiMatrix/reducer';
import snapshot from './snapshot/reducer';
import orp from './orp/reducer';
import orpcompras from './orpcompras/reducer';
import external_review from './external_review/reducer';
import upload from './upload/reducer';
import adminUser from './adminUser/reducer';
import marketintelPrice from './marketintelPrice/reducer';
import marketintelBid from './marketintelBid/reducer';
import marketintelArticle from './marketintelArticle/reducer';
import marketintelSupplier from './marketintelSupplier/reducer';
import marketintelOpenning from './marketintelOpenning/reducer';
import publicationDocument from './publicationDocument/reducer';
import gobAward from './gobAward/reducer';
import award from './award/reducer';
import accessView from './accessView/reducer';
import articleList from './articleList/reducer';
import supplierInfo from './supplierInfo/reducer';
import razonabilidad from './razonabilidad/reducer';
import userRole from './userRole/reducer';
import dataQuality from './dataQuality/reducer';
import menuRole from './menuRole/reducer';
import formKpiLcr from './formKpiLcr/reducer';
import articleCard from './article_card/reducer';

const reducers = combineReducers({
    menu,
    settings,
    authUser,
    catalogList,
    activeIngredient,
    unit,
    dosageForm,
    dosageFormGroup,
    salt,
    dispensingUnit,
    routeAdministration,
    routeAdministrationGroup,
    dataMedication,
    atc,
    unspscFamily,
    unspscClass,
    unspsc,
    news,
    article,
    search,
    user,
    demand,
    acquisition,
    supplier,
    acquisitionDetail,
    code22,
    code22Review, 
    dashboard,
    kpiMatrix,
    snapshot,
    orp,
    orpcompras,
    external_review,
    upload,
    adminUser,
    marketintelPrice,
    marketintelBid,
    marketintelArticle,
    marketintelSupplier,
    marketintelOpenning,
    publicationDocument,
    gobAward,
    award,
    accessView,
    articleList,
    supplierInfo,
    razonabilidad,
    userRole,
    dataQuality,
    menuRole,
    formKpiLcr,
    articleCard
});

export default reducers;
